import { useState } from 'react';
import { useAuth } from '../../lib/AuthContext';
import { Navigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';

const AdminLogin = () => {
  const { user, loading, login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (loading) return <div className="min-h-screen bg-[#09090b] flex items-center justify-center"><p className="text-[#71717a]">Chargement...</p></div>;
  if (user) return <Navigate to="/admin" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#09090b] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <h1 className="text-2xl font-bold text-[#f5f5f5] mb-8 text-center">Cloneia Admin</h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-[#a1a1aa] text-sm mb-1.5">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-2.5 rounded-lg bg-[#1a1a2e] border border-white/10 text-[#f5f5f5] text-sm focus:outline-none focus:border-[#3b82f6]"
              required
              data-testid="admin-login-email"
            />
          </div>
          <div>
            <label className="block text-[#a1a1aa] text-sm mb-1.5">Mot de passe</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-2.5 rounded-lg bg-[#1a1a2e] border border-white/10 text-[#f5f5f5] text-sm focus:outline-none focus:border-[#3b82f6]"
              required
              data-testid="admin-login-password"
            />
          </div>
          {error && <p className="text-red-400 text-sm" data-testid="admin-login-error">{error}</p>}
          <Button
            type="submit"
            disabled={submitting}
            className="w-full bg-[#3b82f6] hover:bg-[#2563eb] text-white py-2.5 rounded-lg font-medium"
            data-testid="admin-login-submit"
          >
            {submitting ? 'Connexion...' : 'Se connecter'}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
